var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShoppingBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.572 7.75C16.572 5.13 14.52 3 12 3 9.48 3 7.43 5.13 7.43 7.75H4v11.281C4 20.671 5.28 22 6.857 22h10.286C18.721 22 20 20.67 20 19.031V7.75h-3.428zM12 4.781c1.576 0 2.857 1.332 2.857 2.969H9.143c0-1.637 1.282-2.969 2.857-2.969zm6.286 14.25c0 .655-.513 1.188-1.143 1.188H6.857c-.63 0-1.142-.533-1.142-1.188v-9.5h1.714v1.485c0 .492.384.89.857.89s.857-.399.857-.89V9.53h5.714v1.485c0 .492.384.89.857.89.474 0 .858-.399.858-.89V9.53h1.714v9.5z",
    fill: "#777"
  })));
}

export default SvgShoppingBag;